export * from './epc-system-implementation';
export * from './registro-system-implementation';


// WEBPACK FOOTER //
// ./src/app/base/use-system/implementation-system/index.ts